/** @jsxImportSource @emotion/react */

import { useState, forwardRef, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { configState } from "../lib/State";
import { Box, Checkbox } from "@mui/material";
import CenterSelect from "./CenterSelect";
import moment from "moment";

const weekOfMonth = () => moment().week() - moment().startOf().week() + 1;

// 등록하기 팝업
export default function ReportMarketingAdd({ login, onClose }) {
  const init_title =
    "마케팅 보고서 " + moment().format("YYYY년 M월 ") + weekOfMonth() + "주";
  const token = localStorage.getItem("token");
  const [tcid, setTcid] = useState("");
  const [rows, setRows] = useState([]);
  const [title, setTitle] = useState(init_title);
  const [sns, setSns] = useState({
    insta: "",
    face: "",
    blog: "",
  });

  useEffect(() => {
    const getQuestion = async () => {
      const result = await axios.post(
        `${process.env.REACT_APP_API}/gympass_admin/ma_report_question`,
        {
          token: token,
          level: login.level,
          mcd: login.mcd,
        }
      );
      if (!result?.data?.success) return;
      setRows(result.data.rows);
    };
    getQuestion();
  }, []);

  const onSubmit = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/ma_report_add",
      {
        token: token,
        level: login.level,
        mcd: login.mcd,
        rows,
        title,
        cid: tcid,
        sns,
      }
    );
    if (result.data.success === 0) {
      Swal.fire("Error", result.data.msg);
      return;
    } else {
      onClose();
    }
  };

  const changeData = (target, value, index) => {
    let copyArray = [...rows];
    if (index !== undefined) {
      const copy = copyArray[index];
      copy[target] = value ? "Y" : "N";
    } else {
      for (let i in copyArray) {
        const copy = copyArray[i];
        copy[target] = value ? "Y" : "N";
      }
    }
    setRows(copyArray);
  };

  return (
    <Box sx={{ padding: 2 }}>
      {/* 가맹점 */}
      <CenterSelect login={login} tcidParent={tcid} setTcidParent={setTcid} />
      {/* 제목 */}
      <Box>
        <TextField
          sx={{ width: "100%", mt: 1 }}
          label="제목"
          size="small"
          onChange={(e) => setTitle(e.target.value)}
          autoComplete="off"
          value={title}
        />
      </Box>
      {/* sns */}
      <Box sx={{ display: "flex", gap: 1 }}>
        <TextField
          sx={{ width: "100%", mt: 1 }}
          name="insta"
          label="인스타"
          size="small"
          onChange={(e) =>
            setSns((state) => ({ ...state, [e.target.name]: e.target.value }))
          }
          autoComplete="off"
          value={sns.insta}
        />
        <TextField
          sx={{ width: "100%", mt: 1 }}
          name="face"
          label="페이스북"
          size="small"
          onChange={(e) =>
            setSns((state) => ({ ...state, [e.target.name]: e.target.value }))
          }
          autoComplete="off"
          value={sns.face}
        />
        <TextField
          sx={{ width: "100%", mt: 1 }}
          name="blog"
          label="블로그"
          size="small"
          onChange={(e) =>
            setSns((state) => ({ ...state, [e.target.name]: e.target.value }))
          }
          autoComplete="off"
          value={sns.blog}
        />
      </Box>
      {/* 리스트 */}
      <Box
        sx={{
          fontSize: "1rem",
          padding: 2,
          mt: 3,
        }}
      >
        <Box
          sx={{
            padding: "1rem 0.3rem",
            display: "grid",
            gridTemplateColumns: "repeat(12, 1fr)",
            gap: 1,
            textAlign: "center",
            fontSize: "1.1rem",
            fontWeight: "bold",
            opacity: 0.8,
            borderBottom: "1px solid lightgray",
            borderTop: "1px solid lightgray",
          }}
        >
          <Box>번호</Box>
          <Box sx={{ gridColumn: "2/12" }}>문항</Box>
          <Box>이행</Box>
        </Box>
        {rows.map((data, index) => (
          <Box
            key={index}
            sx={{
              padding: "0.5rem 0.3rem",
              backgroundColor: index % 2 !== 0 ? "rgba(0,0,0,0.15)" : "",
              borderRadius: "7px",
              display: "grid",
              gridTemplateColumns: "repeat(12, 1fr)",
              gap: 1,
              alignItems: "center",
            }}
          >
            <Box sx={{ opacity: 0.6, textAlign: "center" }}>{index + 1}</Box>
            <Box sx={{ flex: 1, gridColumn: "2/12" }}>{data.question}</Box>
            <Checkbox
              onChange={(e) => changeData("center", e.target.checked, index)}
              checked={data.center === "Y"}
            />
          </Box>
        ))}
      </Box>
      {/* 버튼 */}
      <Box
        sx={{
          mt: 5,
          textAlign: "center",
          display: "flex",
          gap: 1,
          justifyContent: "center",
        }}
      >
        <Button variant="contained" onClick={onSubmit}>
          등록완료
        </Button>
        <Button variant="contained" color="warning" onClick={onClose}>
          닫기
        </Button>
      </Box>
    </Box>
  );
}
